import { find, size, includes } from "lodash";
import { exerciseType } from "../../components/constants/constants";

export default function AssessmentWarnings(data, answers) {
  let answered_exercises = [];
  let answered_pages = [];
  let answered_section = [];
  let answered_question = [];
  let fields;
  let ans = [];
  answers &&
    answers.forEach((answer) => {
      answered_pages.push(answer.page_id);
      answered_section.push(answer.section_id);
      answered_exercises.push(answer.exercise_id);
      if (answer.answers.constructor === Array) {
        answer.answers &&
          answer.answers.forEach((user_selected_answer) => {
            answered_question.push(user_selected_answer.question_id);
            ans.push({
              user_selected_answer,
            });
          });
      }
    });
  let not_completed_exercises = [];
  let not_completed_exercise_with_questions = [];
  data &&
    data.sections &&
    data.sections.forEach((section) => {
      section.pages &&
        section.pages.forEach((page, page_no) => {
          if (page.exercises.length !== 0) {
            page.exercises &&
              page.exercises.forEach((exercise) => {
                if (
                  !includes(answered_exercises, exercise.id) &&
                  !includes(answered_pages, page.id)
                ) {
                  not_completed_exercises.push(page_no + 1);
                  if (exercise.task_type === exerciseType.PRONUNCIATION_TASK || exercise.task_type === "Speaking Task") {
                    let found_section = find(answers, ["section_id", section.id]);
                    let found_page = find(answers, ["page_id", page.id]);
                    let found_exercise = find(answers, [
                      "exercise_id",
                      exercise.id,
                    ]);
                    if (!found_section && !found_page && !found_exercise) {
                      not_completed_exercise_with_questions.push({
                        section_number: section.section_number,
                        pages: [
                          {
                            page_number: page_no + 1,
                          },
                        ],
                      });
                    }
                  }
                  exercise.questions.forEach((question, question_no) => {
                    if (!includes(answered_question, question.id)) {
                      let found_section = find(
                        not_completed_exercise_with_questions,
                        ["section_number", section.section_number]
                      );
                      if (found_section) {
                        let found_page = find(found_section.pages, [
                          "page_number",
                          page_no + 1,
                        ]);
                        if (found_page) {
                          found_page.question_ids.push(question_no + 1);
                        } else {
                          found_section.pages.push({
                            page_number: page_no + 1,
                            question_ids: [question_no + 1],
                          });
                        }
                      } else {
                        not_completed_exercise_with_questions.push({
                          section_number: section.section_number,
                          pages: [
                            {
                              page_number: page_no + 1,
                              question_ids: [question_no + 1],
                            },
                          ],
                        });
                      }
                    }
                  });
                }
                else {
                  answers.forEach((user_selected) => {
                    if (
                      user_selected.exercise_id === exercise.id &&
                      user_selected.section_id === section.id &&
                      user_selected.page_id === page.id
                    ) {
                      if (
                        size(user_selected.answers) !== size(exercise.questions)
                      ) {
                        not_completed_exercises.push(page_no + 1);
                        exercise.questions.forEach((question, question_no) => {
                          let noOfFilelds = [];

                          if (!includes(answered_question, question.id)) {
                            let found_section = find(
                              not_completed_exercise_with_questions,
                              ["section_number", section.section_number]
                            );
                            if (found_section) {
                              let found_page = find(found_section.pages, [
                                "page_number",
                                page_no + 1,
                              ]);
                              if (found_page) {
                                found_page.question_ids.push(question_no + 1);
                              } else {
                                found_section.pages.push({
                                  page_number: page_no + 1,
                                  question_ids: [question_no + 1],
                                });
                              }
                            } else {
                              not_completed_exercise_with_questions.push({
                                section_number: section.section_number,
                                pages: [
                                  {
                                    page_number: page_no + 1,
                                    question_ids: [question_no + 1],
                                  },
                                ],
                              });
                            }
                          } else {
                            if (
                              question.type === "FillInBlankChoices" ||
                              question.type === "FillInBlank"
                            ) {
                              question.prompt_content.replace(
                                /\[\[[^\]]*\]\]/g,
                                function replacer(matched) {
                                  let fieldNumber = `${matched.match(/\d+/)}`;
                                  noOfFilelds.push(fieldNumber);
                                }
                              );
                              fields = size(noOfFilelds);

                              ans.forEach((sel) => {
                                if (
                                  sel["user_selected_answer"]["question_id"] ===
                                  question.id
                                ) {
                                  if (
                                    parseInt(fields) !==
                                    size(
                                      sel["user_selected_answer"][
                                        "selected_answers"
                                      ]
                                    )
                                  ) {
                                    let found_section = find(
                                      not_completed_exercise_with_questions,
                                      ["section_number", section.section_number]
                                    );
                                    if (found_section) {
                                      let found_page = find(
                                        found_section.pages,
                                        ["page_number", page_no + 1]
                                      );
                                      if (found_page) {
                                        found_page.question_ids.push(
                                          question_no + 1
                                        );
                                      } else {
                                        found_section.pages.push({
                                          page_number: page_no + 1,
                                          question_ids: [question_no + 1],
                                        });
                                      }
                                    } else {
                                      not_completed_exercise_with_questions.push(
                                        {
                                          section_number:
                                            section.section_number,
                                          pages: [
                                            {
                                              page_number: page_no + 1,
                                              question_ids: [question_no + 1],
                                            },
                                          ],
                                        }
                                      );
                                    }
                                  }
                                }
                              });
                            }
                          }
                        });
                      } else {
                        exercise.questions.forEach((question, question_no) => {
                          let noOfFilelds = [];
                          if (
                            question.type === "FillInBlankChoices" ||
                            question.type === "FillInBlank"
                          ) {
                            question.prompt_content.replace(
                              /\[\[[^\]]*\]\]/g,
                              function replacer(matched) {
                                let fieldNumber = `${matched.match(/\d+/)}`;
                                noOfFilelds.push(fieldNumber);
                              }
                            );
                            fields = size(noOfFilelds);

                            ans.forEach((sel) => {
                              if (
                                sel["user_selected_answer"]["question_id"] ===
                                question.id
                              ) {
                                if (
                                  parseInt(fields) !==
                                  size(
                                    sel["user_selected_answer"][
                                      "selected_answers"
                                    ]
                                  )
                                ) {
                                  let found_section = find(
                                    not_completed_exercise_with_questions,
                                    ["section_number", section.section_number]
                                  );
                                  if (found_section) {
                                    let found_page = find(found_section.pages, [
                                      "page_number",
                                      page_no + 1,
                                    ]);
                                    if (found_page) {
                                      found_page.question_ids.push(
                                        question_no + 1
                                      );
                                    } else {
                                      found_section.pages.push({
                                        page_number: page_no + 1,
                                        question_ids: [question_no + 1],
                                      });
                                    }
                                  } else {
                                    not_completed_exercise_with_questions.push({
                                      section_number: section.section_number,
                                      pages: [
                                        {
                                          page_number: page_no + 1,
                                          question_ids: [question_no + 1],
                                        },
                                      ],
                                    });
                                  }
                                }
                              }
                            });
                          }
                        });
                      }
                    }
                  });
                }
              });
          } else {
            page.writing_exercises &&
              page.writing_exercises.forEach((exercise) => {
                let found_section = find(answers, ["section_id", section.id]);
                let found_page = find(answers, ["page_id", page.id]);
                let found_exercise = find(answers, [
                  "exercise_id",
                  exercise.id,
                ]);
                if (!found_section && !found_page && !found_exercise) {
                  not_completed_exercise_with_questions.push({
                    section_number: section.section_number,
                    pages: [
                      {
                        page_number: page_no + 1,
                      },
                    ],
                  });
                }
                else if (found_section && found_page && found_exercise && found_exercise.answers)
                  {
                    let words_count =  found_exercise.answers.replace(/[\n]/g, " ").trim().split(" ").length
                    if (words_count < 100)
                    {
                      not_completed_exercise_with_questions.push({
                        section_number: section.section_number,
                        pages: [
                          {
                            page_number: page_no + 1,
                            words_counter: words_count,
                          },
                        ],
                      });
                    }
                }
              });
          }
        });
    });
  return not_completed_exercise_with_questions;
}
